/* eslint-disable no-irregular-whitespace */
/* eslint-disable prefer-destructuring */

const CARTYPE: { [key: string]: string } = {
  HOME_NORMAL_CAR: "11", // 自家用普通乗用車
  HOME_SMALL_CAR: "13", // 自家用小型乗用車
  HOME_SMALL_TRUCK: "49", // 自家用小型貨物車
  HOME_SMALL_FOUR_WHEELED_PASSENGER_CAR: "31", // 自家用軽四輪乗用車
  HOME_SMALL_FOUR_WHEELED_TRUCK: "33" // 自家用軽四輪貨物車
}

const A_TYPE_MAPPING: { [key: string]: string } = {
  "3": CARTYPE.HOME_NORMAL_CAR,
  "5": CARTYPE.HOME_SMALL_CAR,
  "7": CARTYPE.HOME_SMALL_CAR,
  "4": CARTYPE.HOME_SMALL_TRUCK
}

const K_TYPE_MAPPING: { [key: string]: string } = {
  "5": CARTYPE.HOME_SMALL_FOUR_WHEELED_PASSENGER_CAR,
  "7": CARTYPE.HOME_SMALL_FOUR_WHEELED_PASSENGER_CAR,
  "4": CARTYPE.HOME_SMALL_FOUR_WHEELED_TRUCK,
  "6": CARTYPE.HOME_SMALL_FOUR_WHEELED_TRUCK
}

// 読み取った場所のQRコードとして正しいかをチェックする
export const isTypeAQR2 = (text: string): boolean => {
  // 読み取ったQRのデータが'/'が5個かつ'2/'で始まっていれば車検証AのQR2と判定
  const count = (text.match(/\//g) || []).length
  if (count === 5 && text.startsWith("2/")) {
    return true
  }
  return false
}
export const isTypeAQR3 = (text: string): boolean => {
  // 読み取ったQRのデータが'/'が5個か6個かつ'1/と2/'で始まっていなければ車検証AのQR3と判定
  const count = (text.match(/\//g) || []).length
  if ((count === 5 || count === 6) && !text.startsWith("1/") && !text.startsWith("2/") && !text.startsWith("K/")) {
    return true
  }
  return false
}
export const isTypeAQR5 = (text: string): boolean => {
  // 読み取ったQRのデータが'/'が1個かつ'2/'で始まっていれば車検証AのQR5と判定
  const count = (text.match(/\//g) || []).length
  if (count === 1 && text.startsWith("2/")) {
    return true
  }
  return false
}
export const isTypeAQR6 = (text: string): boolean => {
  // 読み取ったQRのデータが'/'が4個かつ最後の'/'の後ろが数字1桁であれば車検証AのQR6と判定
  const count = (text.match(/\//g) || []).length
  if (count === 4 && text.match(/\d{1}/) && !text.startsWith("K/")) {
    return true
  }
  return false
}
export const isTypeKQR4 = (text: string): boolean => {
  // 読み取ったQRのデータが'K/3'で始まっていれば車検証(軽)のQR4と判定
  if (text.startsWith("K/3")) {
    return true
  }
  return false
}
export const isTypeKQR5 = (text: string): boolean => {
  // 読み取ったQRのデータがK/2'で始まっていれば車検証(軽)のQR5と判定
  if (text.startsWith("K/2")) {
    return true
  }
  return false
}

export const QrCheck = (
  typeAResult2: string,
  typeAResult3: string,
  typeAResult5: string,
  typeKResult4: string,
  typeKResult5: string
) => {
  let vehicleType = ""
  let carModel = ""
  let firstInspectionYear = ""
  let firstInspectionMonth = ""
  let firstInspectionDate = ""

  // ---車検証Atype---
  if (typeAResult5) {
    // 車両番号から用途車種の抽出
    const classification = typeAResult5.replace(/　/g, " ").replace(/ +/g, " ").split(" ")[1]
    const firstClassification = classification.slice(0, 1)
    // 半角数字に変換
    const halfFirstClassification = String.fromCharCode(firstClassification.charCodeAt(0) - 0xfee0)
    vehicleType = A_TYPE_MAPPING[halfFirstClassification]
  }
  // 型式の抽出
  if (typeAResult2 && typeAResult3) {
    const fullModel = (typeAResult2 + typeAResult3).split("/")[5]
    carModel = fullModel.split("-")[1]
  }
  // 初度検査年月の抽出
  if (typeAResult2) {
    firstInspectionDate = typeAResult2.split("/")[4]
    firstInspectionYear = `20${firstInspectionDate.slice(0, 2)}`
    firstInspectionMonth = firstInspectionDate.slice(2)
  }

  // ---車検証(軽)---
  if (typeKResult5) {
    // 車両番号から用途車種の抽出
    const classification = typeKResult5.replace(/　/g, " ").replace(/ +/g, " ").split(" ")[1]
    const firstClassification = classification.slice(0, 1)
    // 半角数字に変換
    const halfFirstClassification = String.fromCharCode(firstClassification.charCodeAt(0) - 0xfee0)
    vehicleType = K_TYPE_MAPPING[halfFirstClassification]
  }
  if (typeKResult4) {
    // 型式の抽出
    const fullModel = typeKResult4.split("/")[6]
    carModel = fullModel.split("-")[1]
    // 初度検査年月の抽出
    firstInspectionDate = typeKResult4.split("/")[5]
    firstInspectionYear = `20${firstInspectionDate.slice(0, 2)}`
    firstInspectionMonth = firstInspectionDate.slice(2)
  }

  return {
    vehicleType,
    carModel,
    firstInspectionYear,
    firstInspectionMonth
  }
}
